import { CSSProperties } from 'react';

// How far the floating top clusters slide down when the ticker is shown, so it
// gets its own row instead of overlapping the header buttons. The table
// ticker is ~34px tall; sized against the smallest cluster base offset (8px,
// landscape/grid) rather than portrait's 14px, so all clusters clear it with
// margin (EN-10713 — 30px left only ~4px of clearance for the 8px clusters).
export const TICKER_SHIFT_PX = 40;
export const TICKER_SHIFT_TRANSITION = 'top 0.3s ease';

/**
 * Slides a top-anchored floating cluster down while the ticker is showing, so
 * it gets its own row instead of overlapping the header buttons; reverts when
 * the ticker hides. Pure so it's unit-testable without a DOM (jsdom drops
 * calc/env values).
 */
export const applyTickerShift = (base: CSSProperties, showTicker: boolean): CSSProperties => ({
  ...base,
  // React treats numeric top values as pixels. Keep them numeric rather than
  // producing an invalid mixed-unit expression such as calc(8 + 40px).
  top: showTicker
    ? typeof base.top === 'number'
      ? base.top + TICKER_SHIFT_PX
      : `calc(${String(base.top)} + ${TICKER_SHIFT_PX}px)`
    : base.top,
  transition: base.transition
    ? `${base.transition}, ${TICKER_SHIFT_TRANSITION}`
    : TICKER_SHIFT_TRANSITION
});
